import { app, Component, ojs, payload } from "modular-openscriptjs";
import { either, eParse, formatThousand } from "../../../helpers";
import { dom } from "../../../fotastart";

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");

export default class SuggestedUserView extends Component {
	render(user, ...args) {
		return h.div(
			{
				class: "d-flex flex-column bg-white rounded-4 shadow-sm p-3 gap-2 align-items-center position-relative transition-all hover-translate-y",
				style: "min-width: 160px; max-width: 160px;",
			},
			// Profile Picture
			h.div(
				{
					class: "position-relative",
					style: "width: 80px; height: 80px;",
				},
				h.div(
					{ class: "w-100 h-100" },
					h.img(
						{
							class: "w-100 h-100 rounded-circle object-fit-cover border border-2 border-light shadow-sm",
							id: "user-profile-avatar",
							alt: user?.display_name,
						},
						either(
							user?.profile_photo_path,
							{
								src: user?.profile_photo_path,
								role: "button",
								onclick: h.func(
									"app('broker').send",
									$e.image.needs.view,
									{
										sources: [user?.profile_photo_path],
									}
								),
							},
							{ src: "/assets/images/user-avatar.png" }
						)
					)
				),
				// Badges
				either(
					user?.is_business,
					() =>
						h.span(
							{
								class: "position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow-sm d-flex align-items-center justify-content-center text-info",
								style: "width: 24px; height: 24px;",
								title: "Business Account",
							},
							h.i({ class: "bi bi-shop" })
						),
					either(user?.is_verified, () =>
						h.span(
							{
								class: "position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow-sm d-flex align-items-center justify-content-center text-info",
								style: "width: 24px; height: 24px;",
								title: "Verified Account",
							},
							h.i({ class: "bi bi-patch-check" })
						)
					)
				)
			),

			// Name and Username
			h.div(
				{ class: "text-center w-100" },
				h.div(
					{
						class: "fw-bold text-dark text-truncate fs-sm",
						title: user?.display_name,
					},
					user?.display_name
				),
				h.div(
					{
						class: "d-flex align-items-center justify-content-center gap-1",
					},
					h.span(
						{
							class: "text-muted fs-xsm text-truncate cursor-pointer hover-text-primary",
							onclick: h.func(
								"app('router').to",
								"user.view-profile",
								{
									user:
										user?.id == gc.user?.id
											? "current"
											: user?.id,
								}
							),
						},
						"@",
						user?.username
					),
					h.i({
						class: "fas fa-qrcode text-muted fs-xsm cursor-pointer hover-text-dark",
						onclick: this.method("showUserQR", user),
						title: "Show QR Code",
					})
				)
			),

			// Stats
			h.div(
				{
					class: "d-flex align-items-center justify-content-center gap-2 w-100 py-2 border-top border-light-subtle",
				},
				h.div(
					{
						class: "d-flex flex-column align-items-center cursor-pointer",
						onclick: h.func(
							"app('router').to",
							"user.view-followers",
							{
								user:
									user?.id == gc.user?.id
										? "current"
										: user?.id,
							}
						),
						title: `${formatThousand(
							user.follower_count
						)} Followers`,
					},
					h.span(
						{ class: "fw-bold fs-sm lh-1" },
						formatThousand(user.follower_count)
					),
					h.span({ class: "fs-xxsm text-muted" }, "Followers")
				),
				h.div({ class: "vr opacity-25" }),
				h.div(
					{
						class: "d-flex flex-column align-items-center",
						title: `${formatThousand(user.carted_count)} Carted`,
					},
					h.span(
						{ class: "fw-bold fs-sm lh-1" },
						formatThousand(user.carted_count)
					),
					h.span({ class: "fs-xxsm text-muted" }, "Carted")
				)
			),

			// Follow Button
			h.div(
				{ class: "w-100 mt-auto", f_id: `follow-${user?.id}` },
				h.button(
					{
						class: "btn btn-sm btn-outline-primary w-100 rounded-pill fw-500",
						onclick: this.method("follow", [
							user,
							`follow-${user?.id}`,
						]),
					},
					"Follow"
				)
			),
			...args
		);
	}

	showUserQR(user) {
		broker.send(
			$e.qr.needs.code,
			payload({
				title: `${user?.display_name} (@${user?.username})`,
				data: `/users/profile/${user?.id}`,
			})
		);
	}

	follow(user, uId) {
		broker.send(
			$e.user.needs.toFollow,
			payload({ user, resetViewedUser: true }, { _fId: uId })
		);
	}

	$$user = {
		has: {
			followed: (ed, event) => {
				let data = eParse(ed);

				if (data.meta.has("_fId")) {
					dom.all(`[f-id=${data.meta.get("_fId")}]`)?.forEach((n) =>
						n?.replaceWith(
							h.div(
								{ class: "w-100 text-center" },
								h.button(
									{
										class: "btn btn-sm btn-light w-100 rounded-pill fw-500 text-success disabled border-0",
									},
									h.i({ class: "fas fa-check me-1" }),
									"Following"
								)
							)
						)
					);
				}
			},
		},
	};
}
